import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader, Table } from 'reactstrap';
import { List } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import GMButton from '../Button';
import client from '../../utils/client';

interface Payout {
  id: string;
  saleAmountIncl: number;
  saleAmountExcl: number;
  transactionFee: number;
  invAmountExcl: number;
  invAmountIncl: number;
  dueDate: string;
  articles?: Array<{
    code: string;
    name: string;
    quantity: number;
    sumExcl: number;
    sumIncl: number;
  }>;
}

const WebSalePayouts = () => {
  const [inProgress, setInProgress] = useState(false);
  const [payouts, setPayouts] = useState<Array<Payout> | null>(null);
  const [payout, setPayout] = useState<Payout | null>(null);

  const { t } = useTranslation();

  useEffect(() => {
    (async () => {
      const po: any = await client('admin-gc/web-sales/reports');
      setPayouts(po?.data);
    })();
  }, []);

  const downloadPayoutFile = async () => {
    setInProgress(true);
    await client(
      `admin-gc/web-sales/reports/csv?report-id=${payout?.id}`,
      { body: null },
      'get',
      true
    );
    setInProgress(false);
  };

  const downloadInvoiceFile = async () => {
    setInProgress(true);
    await client(
      `admin-gc/web-sales/reports/invoice?report-id=${payout?.id}`,
      { body: null },
      'get',
      true
    );
    setInProgress(false);
  };

  return (
    payouts && (
      <>
        <Table striped responsive className="mb-5">
          <thead className="thead-light">
            <tr>
              <th>Id</th>
              <th>{t('web-sales.payout.sales-inc-vat')}</th>
              <th>{t('web-sales.payout.sales-ex-vat')}</th>
              <th>{t('web-sales.payout.transaction-fee-ex-vat')}</th>
              <th>{t('web-sales.payout.payout-ex-vat')}</th>
              <th>{t('web-sales.payout.payout-inc-vat')}</th>
              <th>{t('web-sales.payout.payout-date')}</th>
            </tr>
          </thead>
          <tbody className="thead-light">
            {payouts?.map((p) => (
              <tr key={p.id}>
                <td>
                  <GMButton
                    color="link"
                    className="only-icon"
                    label={p.id}
                    icon={<List />}
                    onClick={() => setPayout(p)}
                  />
                </td>
                <td>{p.saleAmountIncl}</td>
                <td>{p.saleAmountExcl}</td>
                <td>{p.transactionFee}</td>
                <td>{p.invAmountExcl}</td>
                <td>{p.invAmountIncl}</td>
                <td>{p.dueDate}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        {payout && (
          <Modal isOpen centered size="lg">
            <ModalHeader toggle={() => setPayout(null)}>
              {t('web-sales.payout.report-details')}
            </ModalHeader>
            <ModalBody>
              <Table striped responsive>
                <thead className="thead-light">
                  <tr>
                    <th>{t('web-sales.payout.product')}</th>
                    <th>{t('web-sales.payout.quantity')}</th>
                    <th>{t('web-sales.payout.sum-excl-vat')}</th>
                    <th>{t('web-sales.payout.sum-incl-vat')}</th>
                  </tr>
                </thead>
                <tbody>
                  {payout.articles?.map((p) => (
                    <tr key={p.code}>
                      <td>{p.name || p.code}</td>
                      <td>{p.quantity}</td>
                      <td>{p.sumExcl}</td>
                      <td>{p.sumIncl}</td>
                    </tr>
                  ))}
                  <tr>
                    <th>{t('web-sales.payout.total')}</th>
                    <th> </th>
                    <th>{payout.invAmountExcl}</th>
                    <th>{payout.invAmountIncl}</th>
                  </tr>
                </tbody>
              </Table>
              <GMButton
                label={t('web-sales.payout.download-report', 'Ladda ner rapport')}
                onClick={downloadPayoutFile}
                disabled={!!inProgress}
              />
              <GMButton
                label={t('web-sales.payout.download-invoice', 'Ladda ner faktura')}
                onClick={downloadInvoiceFile}
                disabled={!!inProgress}
              />
            </ModalBody>
          </Modal>
        )}
      </>
    )
  );
};

export default WebSalePayouts;
